// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import BulletGrid from '@/components/sections/BulletGrid'

// Style
import themeColors from 'assets/theme/colors'

export default function GainsSection() {
  const { t } = useTranslation('servicesOtAwarenessTraining')

  const items = [
    t('gains.items.01'),
    t('gains.items.02'),
    t('gains.items.03'),
    t('gains.items.04'),
    t('gains.items.05'),
    t('gains.items.06')
  ]

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader
        eyebrow={t('gains.eyebrow')}
        title={t('gains.title')}
        intro={[t('gains.intro1'), t('gains.intro2')]}
      />

      <BulletGrid items={items} columns={2} />
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.section.light}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
